import "./App.scss";
import { Outlet } from "react-router-dom";

function App() {
  return (
    <div
      className="App"
      style={{ width: "100%", height: "100%" }}
      data-testid="app-container"
    >
      <Outlet />
    </div>
  );
}

export default App;
